var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashCan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "trash",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.648,
    height: 14.336,
    viewBox: "0 0 11.648 14.336",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7343",
    "data-name": "Path 7343",
    d: "M58.528,1.792H56.064V1.344A1.344,1.344,0,0,0,54.72,0H52.928a1.344,1.344,0,0,0-1.344,1.344v.448H49.12A1.12,1.12,0,0,0,48,2.912v.9a.448.448,0,0,0,.448.448H59.2a.448.448,0,0,0,.448-.448v-.9A1.12,1.12,0,0,0,58.528,1.792ZM52.48,1.344A.449.449,0,0,1,52.928.9H54.72a.449.449,0,0,1,.448.448v.448H52.48Z",
    transform: "translate(-48)",
    fill: "#f65858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7344",
    "data-name": "Path 7344",
    d: "M73.5,184a.14.14,0,0,0-.14.147l.37,7.757a1.342,1.342,0,0,0,1.342,1.28h6.8a1.342,1.342,0,0,0,1.342-1.28l.37-7.757a.14.14,0,0,0-.14-.147Zm6.766,1.12a.448.448,0,0,1,.9,0v5.824a.448.448,0,1,1-.9,0Zm-2.24,0a.448.448,0,0,1,.9,0v5.824a.448.448,0,1,1-.9,0Zm-2.24,0a.448.448,0,0,1,.9,0v5.824a.448.448,0,1,1-.9,0Z",
    transform: "translate(-72.654 -178.848)",
    fill: "#f65858"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCan);
export default __webpack_public_path__ + "static/media/trash-can.72efcf3cf5392037fe6729a77f6b7e62.svg";
export { ForwardRef as ReactComponent };